// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Testimonial.scss';
import discoverStyle from '../../../modules/home/components/Discover/Discover.scss';
import icons from '../../../assets/styles/icons.scss';

import type { Element } from 'react';
import type { Country } from '../../../entities';

type Props = {
  //handleClick: (e: Event) => void;
  item: TestimonialItem;
  userType: 'purchaser' | 'traveler';
};

export type TestimonialItem = {
  image: string;
  name: string;
  textIntl: string;
  //video: string;
  flight?: {
    departure: string;
    arrival: string;
  };
};

export default class Testimonial extends Component<Props> {
  render() {
    const { item, userType } = this.props;
    return (
      <article className={style.testimonialWrap}>
        <section className={classNames(style.testimonial, style[userType])}>
          <section className={style.imageWrap}>
            {/*<button className={classNames(discoverStyle.discover, style.discover, discoverStyle.white)}
                    onClick={handleClick}
                    type="button">
              <div className={discoverStyle.circleAndPlay}>
                <i className={classNames(icons.symbolPlay, style[userType === 'purchaser' ? 'lightBlue' : 'orange'])}/>
              </div>
            </button>*/}
            <img src={item.image} alt={item.name}/>
          </section>
          <section className={style.content}>
            <p className={style.name}>{item.name}</p>
            {userType === 'traveler' && item.flight && (
              <section className={style.flight}>
                <p>{item.flight.departure}</p>
                <div>
                  <span>&#8226;</span>
                  <i className={icons.iconAirplaneMedium}/>
                  <span>&#8226;</span>
                </div>
                <p>{item.flight.arrival}</p>
              </section>)}
            <FormattedMessage id={item.textIntl}>{
              txt => <p className={style.text}>{txt}</p>
            }</FormattedMessage>
          </section>
        </section>
      </article>);
  }
}

Testimonial.propTypes = {
  item: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/CarouselTestimonials/Testimonial/Testimonial.jsx